export enum DateFormats {
    DDMMMYYYY = '0',
    DDMMYYYY = '1',
    MMYYYY="MMYYYY",
    DDMMMYYYYHyphen='2',
}